export default "__VITE_ASSET__ufhhMdQU__"